import antdEs from "antd/lib/locale/es_ES";
import appLocaleData from "react-intl/locale-data/es";
// es.json is exported from POEditor by the deploy (yarn poeditor:download:translations).
import esMessages from "../locales/es.json";
import pendingEs from "../locales/pending/es.json";
// Anything not translated yet falls back to English instead of showing the raw key.
import enMessages from "../locales/en.json";
import pendingEn from "../locales/pending/en.json";
import 'moment/locale/es';

const EsLang = {
  messages: {
    ...pendingEn,
    ...enMessages,
    ...pendingEs,
    ...esMessages
  },
  antd: antdEs,
  locale: 'es',
  data: appLocaleData
};
export default EsLang;
